<template>
  <div class="quoteItem">
    <div v-if="showBadge && isRecommended" class="quoteItemRecommended">
      <img src="../assets/images/recommended_lightbulb.svg" class="recommendedIcon" alt="" />
      {{ $t('text.recommended') }}
    </div>
    <div class="quoteItemBox" :class="{ quoteItemBoxRecommended: isRecommended }">
      <div v-if="categoryKey" class="quoteItemCategory">{{ $t(categoryKey) }}</div>
      <div class="quoteItemTitle">
        <h2>{{ displayName }}</h2>
        <p v-if="descriptionKey" class="quoteItemPlanDescription">{{ $t(descriptionKey) }}</p>
      </div>
      <div class="quoteItemPrice">
        {{ formattedPrice }}<sup v-if="showPriceAsterisk" class="price-asterisk">*</sup>
      </div>
      <div class="quoteItemDivider"></div>
      <div class="quoteItemBenefits">
        <div v-for="benefitKey in benefitKeys" :key="benefitKey" class="quoteBenefitRow">
          <img src="../assets/images/checkmark_dark.svg" class="checkIcon" alt="" />
          <span>{{ $t(benefitKey) }}</span>
        </div>
      </div>
      <div class="quoteItemDivider"></div>
      <template v-if="exclusionKey">
        <div class="quoteItemAccordion" :class="{ open: accordionOpen }">
          <div v-if="accordionOpen" class="accordionActiveBar" aria-hidden="true"></div>
          <div class="accordionBody">
            <button
              type="button"
              class="accordionHeader"
              :aria-expanded="accordionOpen ? 'true' : 'false'"
              @click="accordionOpen = !accordionOpen"
            >
              <span>{{ $t('text.whatsnotincluded') }}</span>
              <img
                src="../assets/images/chevron_down_red.svg"
                class="accordionChevron"
                :class="{ open: accordionOpen }"
                alt=""
              />
            </button>
            <div v-if="accordionOpen" class="accordionContent">
              <p v-html="$t(exclusionKey)"></p>
            </div>
          </div>
        </div>
        <div class="quoteItemDivider"></div>
      </template>
      <div class="quoteItemFooter">
        <div class="quoteItemActions">
          <button
            type="button"
            class="btn btn-select"
            :aria-label="selectAriaLabel"
            @click="$emit('select', product)"
          >{{ $t(selectKey) }}</button>
          <a
            class="moreDetails"
            href="javascript:void(0);"
            :aria-label="moreDetailsAriaLabel"
            @click="$emit('more-details', product)"
          ><span>{{ $t(moreDetailsKey) }}</span><span aria-hidden="true">&gt;</span></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import getQuotePlanCopy from "../utils/quotePlanCopy.js";
import getQuoteCardBenefitKeys from "../utils/quoteCardBenefits.js";

export default {
  name: "QuotePlanCard",
  props: {
    product: {
      type: Object,
      required: true
    },
    showBadge: {
      type: Boolean,
      default: true
    }
  },
  emits: ["select", "more-details"],
  data() {
    return {
      accordionOpen: false
    };
  },
  computed: {
    isRecommended() {
      return this.product.recommended === true;
    },
    planCopy() {
      return getQuotePlanCopy(this.product.Product.ProductCode);
    },
    categoryKey() {
      return this.planCopy.category || null;
    },
    descriptionKey() {
      return this.planCopy.description || null;
    },
    exclusionKey() {
      return this.planCopy.exclusion || null;
    },
    selectKey() {
      return this.planCopy.select || "text.selectthisplan";
    },
    moreDetailsKey() {
      return this.planCopy.moreDetails || "text.quotemoredetails";
    },
    displayName() {
      return this.planCopy.fullName ? this.$t(this.planCopy.fullName) : this.product.Product.Name;
    },
    benefitKeys() {
      return this.planCopy.benefits || getQuoteCardBenefitKeys(this.product.Product.Benefits);
    },
    recommendedLabel() {
      return this.isRecommended ? this.$t('text.recommended') : "";
    },
    formattedPrice() {
      let price = Number(this.product.Total);
      const parts = String(this.product.Total).split(".");
      if (parts.length === 1 || parts[1].length < 3) {
        price = price.toFixed(2);
      }
      return "$" + price;
    },
    showPriceAsterisk() {
      return this.$store.state.site === "cibc";
    },
    selectAriaLabel() {
      return this.$t("text.select") + " " + this.displayName + ", " + this.recommendedLabel;
    },
    moreDetailsAriaLabel() {
      return this.$t("text.moredetailson") + " " + this.displayName + ", " + this.recommendedLabel;
    }
  }
};
</script>
